<div *ngIf="consumers.length > 0">
  <h3>Verbraucher</h3>
  <section *ngFor="let consumer of consumers; first as isFirst; last as isLast">
    <h4>
      <span *ngIf="consumer.count">{{ consumer.count.toString() }} x</span>
      {{ consumer.manufacturer }}
      <span *ngIf="consumer.manufacturer && consumer.deviceTypeName">-</span>
      {{ consumer.deviceTypeName }}
    </h4>

    <div>
      <app-value-with-label
        *ngIf="consumer.location"
        [label]="'Art des Standorts:'"
        [value]="consumer.location | powerLocationTypePipe"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.sitePlanAvailable"
        [label]="'Lageplan vorhanden:'"
        [value]="consumer.sitePlanAvailable ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.chargeDeviceAvailable"
        [label]="'Ladeeinrichtung im Übersichtsschaltplan zur Kundeanlage dargestellt:'"
        [value]="consumer.chargeDeviceAvailable ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.chargingPointsNumber"
        [label]="'Anzahl der Ladepunkte insgesamt:'"
        [value]="consumer.chargingPointsNumber.toString()"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.manufacturerDeclaration"
        [label]="'Herstellererklärung vorhanden? (Einhaltung der anerkannten Regeln der Technik):'"
        [value]="consumer.manufacturerDeclaration ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>

    <h4 style="padding-top: 1em">Ausführung der Ladeeinrichtung</h4>

    <div>
      <app-value-with-label
        *ngIf="consumer.extractionPowerMax"
        [label]="'Max. Netzentnahmeleistung (kVA):'"
        [value]="consumer.extractionPowerMax.toString()"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="consumer.feedPowerMax"
        [label]="'Max. Netzeinspeiseleistung (kVA):'"
        [value]="consumer.feedPowerMax.toString()"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="consumer.chargingRangeFrom"
        [label]="'Regelbereich der Ladeleistung von (kVA):'"
        [value]="consumer.chargingRangeFrom.toString()"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="consumer.chargingRateTo"
        [label]="'Regelbereich der Ladeleistung bis (kVA):'"
        [value]="consumer.chargingRateTo.toString()"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.acCurrent"
        [label]="'Bei Wechselstrom:'"
        [value]="consumer.acCurrent.toString()"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.interruptibleChargingSystem"
        [label]="'Ladeeinrichtung als unterbrechbare Verbrauchseinrichtung möglich:'"
        [value]="consumer.interruptibleChargingSystem ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>

    <div>
      <app-value-with-label
        *ngIf="consumer.chargingStationInterface"
        [label]="'Schnittstelle Ladesäule-Netzbetreiber vorhanden:'"
        [value]="consumer.chargingStationInterface ? 'Ja' : 'Nein'"></app-value-with-label>
    </div>
  </section>
</div>
